/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveOutcomeCredit } from '../models/ApiWaveOutcomeCredit';
import { ApiWaveOutcomeSubType } from '../models/ApiWaveOutcomeSubType';
import { ApiWaveOutcomeType } from '../models/ApiWaveOutcomeType';
import { HttpFile } from '../http/http';

export class ApiWaveDecisionAward {
    'type': ApiWaveOutcomeType;
    'subtype'?: ApiWaveOutcomeSubType;
    'description': string;
    'credit'?: ApiWaveOutcomeCredit;
    'rep_category'?: string;
    'amount'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "ApiWaveOutcomeType",
            "format": ""
        },
        {
            "name": "subtype",
            "baseName": "subtype",
            "type": "ApiWaveOutcomeSubType",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "credit",
            "baseName": "credit",
            "type": "ApiWaveOutcomeCredit",
            "format": ""
        },
        {
            "name": "rep_category",
            "baseName": "rep_category",
            "type": "string",
            "format": ""
        },
        {
            "name": "amount",
            "baseName": "amount",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveDecisionAward.attributeTypeMap;
    }

    public constructor() {
    }
}



